import React from "react";

type CancelRescheduleFormProps = {
  candidateID: string;
  setCandidateID: (id: string) => void;
  searchLoading: boolean;
  handleSearch: () => void;
};

const labelStyle: React.CSSProperties = {
  fontSize: "15px",
  fontWeight: 600,
  color: "#333",
  marginBottom: "6px",
};

const inputStyle: React.CSSProperties = {
  width: "100%",
  padding: "10px 12px",
  border: "1px solid #ccc",
  borderRadius: "8px",
  fontSize: "14px",
  outline: "none",
};

export const CancelRescheduleForm: React.FC<CancelRescheduleFormProps> = ({
  candidateID,
  setCandidateID,
  searchLoading,
  handleSearch,
}) => {
  return (
    <div style={{ padding: 24 }}>
      <div style={{ display: "flex", gap: 10 }}>
        <div style={{ display: "flex", flexDirection: "column", flex: 1 }}>
          <label style={labelStyle}>Candidate ID</label>
          <input
            disabled={searchLoading}
            type="text"
            value={candidateID}
            onChange={(e) => setCandidateID(e.target.value)}
            style={inputStyle}
          />
        </div>
        <button
          type="button"
          disabled={searchLoading || !candidateID}
          onClick={handleSearch}
          style={{
            backgroundColor:
              searchLoading || !candidateID ? "#94a3b8" : "#2563eb",
            color: "#fff",
            padding: "10px 24px",
            border: "none",
            borderRadius: "8px",
            fontSize: "16px",
            fontWeight: "600",
            height: "max-content",
            alignSelf: "end",
            cursor: searchLoading || !candidateID ? "not-allowed" : "pointer",
          }}
        >
          {searchLoading ? "Searching..." : "Search"}
        </button>
      </div>
    </div>
  );
};
